<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import useSeo from '@/composables/useSeo';
import { getStandardSeoSuffixes } from '@/utils/seoConstants';
import {
  affiliateConfigs,
  type AffiliateConfig,
} from '~/utils/perfilOficialConfigs';
import { useLayoutStore } from '@/stores/layout';

const route = useRoute();
const router = useRouter();
const layoutStore = useLayoutStore();
const perfil = computed(() => route.params.perfil as string);
const promocodeFromQuery = computed(
  () => route.query.promocode as string | undefined,
);

const shouldRenderAffiliateContent = computed(() => {
  return route.path.startsWith('/perfil-oficial');
});

const isLoading = ref(true);
const affiliateConfigData = ref<AffiliateConfig | undefined>(undefined);
const perfilSlug = ref('');

const loadAffiliateConfig = async () => {
  isLoading.value = true;

  const { standardTitleSuffix } = getStandardSeoSuffixes();

  await new Promise((resolve) => setTimeout(resolve, 500));

  const name = perfil.value?.toLowerCase().replace(/-/g, '');

  perfilSlug.value = perfil.value?.toLowerCase();

  if (affiliateConfigs[name]) {
    affiliateConfigData.value = affiliateConfigs[name];
    layoutStore.setDarkTheme(
      affiliateConfigData.value.backgroundColor === '#000000',
    );

    if (
      affiliateConfigData.value.affiliateDetails?.name &&
      route.path.includes('perfil-oficial')
    ) {
      useSeo({
        title: `${affiliateConfigData.value.affiliateDetails.name} ${standardTitleSuffix}`,
      });
    }
  } else if (perfil.value && route.path.includes('perfil-oficial')) {
    router.replace('/perfil-oficial/');
  }
  isLoading.value = false;
};

onMounted(() => {
  loadAffiliateConfig();
});

onUnmounted(() => {
  layoutStore.setDarkTheme(false);
});

const config = computed<AffiliateConfig | undefined>(() => {
  return affiliateConfigData.value;
});
</script>

<template>
  <div
    v-if="shouldRenderAffiliateContent"
    class="min-h-[80vh]"
  >
    <div
      v-if="isLoading"
      class="flex items-center justify-center min-h-[80vh]"
    >
      <div class="animate-pulse">
        <ApLogoIcon class="w-16 h-16 opacity-60" />
      </div>
    </div>
    <div v-else-if="config">
      <PerfilOficialGamesPage
        :config="config"
        :is-roletas-page="config?.backgroundColor === '#000000'"
        :perfil-slug="perfilSlug"
        :promocode="promocodeFromQuery"
      />
    </div>
  </div>
  <div
    v-else-if="!shouldRenderAffiliateContent || !config"
    class="flex items-center justify-center min-h-[80vh]"
  >
    <div class="animate-pulse">
      <ApLogoIcon class="w-16 h-16 opacity-60" />
    </div>
  </div>
</template>
